// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2dpAi","emails":"CreateEditClinics_emails__saA_Z","emailTagLabel":"CreateEditClinics_emailTagLabel__3UmgK"};